<template>
  <div class="d-flex align-center">
    <v-avatar color="tertiary"
              size="32"
              class="mr-2"
    >
      <span class="text-white text-uppercase">{{ item.shortInitials }}</span>
    </v-avatar>
    <div>
      <div class="text-text-secondary">
        {{ item.firstName }} {{ item.lastName }}
        <span v-if="withCompany && item.company" class="body-md-bold">({{ item.company }})</span>
      </div>
      <div class="detail-md-regular text-text-tertiary">{{ item.email }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddMemberFormComboboxItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    withCompany: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
